import { IconContainerWithButton } from 'components/DesignSystems/IconContainerWithButton/IconContainerWithButton';
import WizardButtonWrapper from '../Wizard/WizardButtonWrapper';
import { FlowType } from 'types/template';

type Props = {
  onModalClose: () => void;
  handleFlowSelect: (flow: FlowType) => void;
  handleStepTransition: () => void;
  selectedFlow: FlowType | null;
};

export default function SelectTemplateFlow({
  onModalClose,
  handleFlowSelect,
  handleStepTransition,
  selectedFlow,
}: Props) {
  return (
    <div className="right-content d-flex flex-column align-items-start justify-content-between">
      <div className="w-100 d-flex flex-row gap-4">
        {/* NOTE (5/7/2025): Commenting this out, as the teams_integration repo hasn't been updated
        for actual deployments yet, so you can't actually submit custom templates */}
        {/* <IconContainerWithButton
          buttonText="Create New"
          description="Custom-build your team setup to match unique operational demands, ensuring a tailored approach to team roles and responsibilities."
          title="Create New"
          onButtonClick={() => handleFlowSelect('new')}
          icon="add"
          className={selectedFlow === 'new' ? 'selected' : ''}
        /> */}
        <IconContainerWithButton
          buttonText="Use Existing"
          description="Implement existing Teams templates to expedite setup, leveraging established structures for quick operational integration."
          title="Use Existing Templates"
          onButtonClick={() => handleFlowSelect('existing')}
          icon="file_copy"
          className={selectedFlow === 'existing' ? 'selected' : ''}
        />
      </div>
      <WizardButtonWrapper
        onModalClose={onModalClose}
        buttonProps={[
          {
            onClick: handleStepTransition,
            text: 'Next',
            isPrimary: true,
          },
        ]}
      />
    </div>
  );
}
